import { supabase } from '../client'
import type { Profile } from '../types'
import { logSupabaseError } from './logSupabaseError'

/* ── PROFILE ─────────────────────────────────────────── */

/**
 * Get user profile
 */
export async function getProfile(userId: string): Promise<Profile | null> {
  if (!supabase) return null

  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single()

    if (error) {
      logSupabaseError('Get profile error', error)
      return null
    }

    return data
  } catch (error) {
    logSupabaseError('Get profile error', error)
    return null
  }
}

/**
 * Update user profile
 */
export async function updateProfile(
  userId: string,
  updates: Partial<Omit<Profile, 'id' | 'email' | 'created_at'>>
): Promise<boolean> {
  if (!supabase) return false

  try {
    const { error } = await supabase
      .from('profiles')
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('id', userId)

    if (error) {
      logSupabaseError('Update profile error', error)
      return false
    }

    return true
  } catch (error) {
    logSupabaseError('Update profile error', error)
    return false
  }
}
